var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbsDownred(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7224 2.625H3.975C3.64363 2.625 3.375 2.89363 3.375 3.225V10.275C3.375 10.6064 3.64363 10.875 3.975 10.875H5.61762C6.32014 10.875 6.97116 11.2436 7.33261 11.846L9.21977 14.9913C9.6584 15.7223 10.6915 15.7918 11.2241 15.1261C11.4752 14.8123 11.5561 14.3952 11.4406 14.0103L10.7317 11.6474C10.6162 11.2624 10.9045 10.875 11.3064 10.875H13.8815C15.2002 10.875 16.158 9.62105 15.811 8.34877L14.6519 4.09877C14.4146 3.22864 13.6243 2.625 12.7224 2.625Z",
    stroke: "#A40E17",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10.875L6 2.625",
    stroke: "#A40E17",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDownred);
export default __webpack_public_path__ + "static/media/thumbs-downred.8e58db4d3c42874568e81b8e856b07f1.svg";
export { ForwardRef as ReactComponent };